<footer class="dalel-footer" dir="rtl">
  <div class="shell">
    <div class="footer-grid">
      <div class="footer-col">
        <img class="footer-logo" src="assets/images/home/logo.png" alt="دليل بلس" />
        <p class="footer-note">
          منصة تجمعك بأفضل مقدمي الخدمات حولك، لتجد ما تحتاجه بسهولة وفي وقت أقل.
        </p>
      </div>

      <div class="footer-col">
        <h4>روابط مفيدة</h4>
        <a routerLink="/home">الرئيسية</a>
        <a routerLink="/nearest">مقدمو الخدمات</a>
        <a routerLink="/terms-conditions">أحكام وشروط</a>
        <a routerLink="/privacy">سياسة الخصوصية</a>
        <a routerLink="/exchange-return">سياسة الاستبدال والاسترجاع</a>
      </div>

      <div class="footer-col">
        <h4>مساعده</h4>
        <a *ngIf="!user" routerLink="/auth/signin">تسجيل دخول</a>
        <a routerLink="/auth/register">إنشاء حساب</a>
        <a *ngIf="user" routerLink="/account">حسابي</a>
        <a *ngIf="user" (click)="logout()">تسجيل الخروج</a>
      </div>

      <div class="footer-col">
        <h4>تواصل معنا</h4>
        <p>نسعد بخدمتك والإجابة عن استفساراتك</p>
        <a href="mailto:info&#64;dalel.sa">info&#64;dalel.sa</a>
        <a href="https://wa.me/966535354922" target="_blank" rel="noopener">واتساب الدعم</a>
      </div>
    </div>

    <div class="copyright">
      <span>© جميع الحقوق محفوظة لموقع دليل بلس {{ currentYear }}</span>
      <div class="hosting-credit">
        <span>تصميم واستضافه</span>
        <a href="https://smartlines-eg.com/" target="_blank" rel="noopener noreferrer">سمارت لاينز للنظم المتطورة</a>
      </div>
    </div>
  </div>
</footer>
